"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@ag-grid-community/react");
const react_router_dom_1 = require("react-router-dom");
const gridUtils_1 = require("../gridUtils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const createCatalogsExportSummaryColumns_1 = require("./createCatalogsExportSummaryColumns");
const handleError_1 = __importDefault(require("../../handleError"));
const api_1 = require("../../api");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const rich_select_1 = require("@ag-grid-enterprise/rich-select");
const Button_1 = __importDefault(require("../../forms/Button"));
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../utils");
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const use_debounce_1 = require("use-debounce");
var quickFilterParsedValue = [];
const CatalogExportSummaryGrid = () => {
    const { user } = (0, AuthContext_1.useAuth)();
    const history = (0, react_router_dom_1.useHistory)();
    const [gridApi, setGridApi] = (0, react_1.useState)(null);
    const columns = [];
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const catalogsExportMetadataApi = new api_1.CatalogsExportMetadataApi();
    const updateData = async (updates, apiG) => {
        const apiGrid = apiG || gridApi;
        try {
            const data = await catalogsExportMetadataApi.updateSummary({ updates });
            const summaries = data.summaries;
            // update summary generated on the backend
            summaries.forEach((summary) => {
                const rowNode = gridApi.getRowNode(String(summary.id));
                rowNode.setDataValue('catalog_summary', summary.summary);
            });
        }
        catch (error) {
            (0, handleError_1.default)(error);
            apiGrid?.undoCellEditing();
        }
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updateData, 250);
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                debouncedUpdate({ id, column, value: newValue });
            }
            catch (e) {
                (0, handleError_1.default)(e);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (gridApi)
            gridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['gattung'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        multiSortKey: 'ctrl',
        getRowNodeId: (data) => {
            return data.id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
    };
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
        rich_select_1.RichSelectModule
    ];
    function onGridReady(params) {
        setGridApi(params.api);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await catalogsExportMetadataApi.summaryIndex();
                params.api.setColumnDefs((0, createCatalogsExportSummaryColumns_1.createCatalogsExportSummaryColumns)());
                params.api.setRowData(data.items);
            }
            catch (e) {
                (0, handleError_1.default)(e);
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const resetFilters = () => {
        gridApi.setFilterModel(null);
        setQuickFilterText('');
        gridApi.onFilterChanged();
    };
    const resetCatalogData = async () => {
        if (confirm('Die unter Schritt 3 erfassten Daten werden nicht gespeichert. Fortfahren?')) {
            await catalogsExportMetadataApi.reset();
            history.push('/');
        }
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, onCellKeyDown: gridUtils_1.onCellKeyDown, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: [], getRowNodeId: (data) => data.id, onCellValueChanged: cellValueChanged }));
    }, [columns, gridApi]);
    return (react_1.default.createElement("div", { className: 'ag-theme-balham flex flex-col w-full flex-1' },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche Gattung...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement("a", { href: "/catalogs/export/download", className: "link-button", target: "_blank" }, "Download Export"),
                react_1.default.createElement(Button_1.default, { title: 'Die unter Schritt 3 erfassten Daten werden nicht gespeichert!', variant: 'red', onClick: () => { resetCatalogData(); } }, "Alle Daten zur\u00FCcksetzen")),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => gridApi.undoCellEditing(), size: 'sm', variant: 'white' }, "Undo"),
                react_1.default.createElement(Button_1.default, { onClick: () => gridApi.redoCellEditing(), size: 'sm', variant: 'white' }, "Redo"))),
        gridTable));
};
exports.default = CatalogExportSummaryGrid;
